<template>
  <h2 class="q-number" :style="{ color, fontSize }">
    <span v-if="qPrefix">
      <span class="underline">
      {{ qPrefix }}
      </span>{{ qSuffix }}
    </span>
    <span v-else>
      {{ qNumber }}
    </span>
  </h2>
</template>

<script>
const props = {
  qNumber: {
    type: String,
    required: false
  },
  qPrefix: {
    type: String,
    default: ''
  },
  qSuffix: {
    type: String,
    default: ''
  },
  fontSize: {
    type: String,
    default: '1.4rem'
  },
  color: {
    type: String,
    default: '#000000'
  }
}

export default {
  name: 'qNumber',
  props
}
</script>

<style lang="scss" scoped>
  .q-number {
    font-family: 'Lato', sans-serif;
    text-align: center;

    .underline {
      display: inline-block;
      text-decoration: underline;
    }
  }
</style>
